<template>
  <div class="org-teachers">
    <el-card>
      <div slot="header" class="card-header">
        <span>教师管理</span>
        <div class="header-actions">
          <el-input
            v-model.trim="bindUsername"
            placeholder="输入教师 username 进行绑定"
            style="width: 260px"
            clearable
            @keyup.enter.native="bindTeacher"
          >
            <el-button slot="append" type="primary" :loading="binding" @click="bindTeacher">绑定</el-button>
          </el-input>
          <el-button icon="el-icon-refresh" @click="loadTeachers" :loading="loading">刷新</el-button>
        </div>
      </div>

      <el-table :data="teachers" v-loading="loading" stripe>
        <el-table-column prop="teacherUserId" label="教师用户ID" width="120" />
        <el-table-column prop="teacherUsername" label="用户名" min-width="200" />
        <el-table-column prop="createdAt" label="绑定时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-popconfirm title="确定解绑该教师吗？" @onConfirm="unbindTeacher(scope.row)">
              <el-button slot="reference" type="text" size="small">解绑</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="!loading && (!teachers || teachers.length === 0)" class="empty">暂无已绑定教师</div>
    </el-card>
  </div>
</template>

<script>
import { listOrgTeachers, bindOrgTeacher, unbindOrgTeacher } from '@/api/organization'

export default {
  name: 'OrgTeachers',
  data() {
    return {
      loading: false,
      teachers: [],
      bindUsername: '',
      binding: false
    }
  },
  created() {
    this.loadTeachers()
  },
  methods: {
    async loadTeachers() {
      this.loading = true
      try {
        const res = await listOrgTeachers()
        if (res && res.code === 1) {
          this.teachers = res.data || []
        } else {
          this.$message.error((res && res.msg) || '加载失败')
        }
      } catch (e) {
        console.error('加载失败:', e)
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    async bindTeacher() {
      if (!this.bindUsername) {
        this.$message.warning('请输入教师username')
        return
      }
      this.binding = true
      try {
        const res = await bindOrgTeacher({ username: this.bindUsername })
        if (res && res.code === 1) {
          this.$message.success('绑定成功')
          this.bindUsername = ''
          await this.loadTeachers()
        } else {
          this.$message.error((res && res.msg) || '绑定失败')
        }
      } catch (e) {
        console.error('绑定失败:', e)
        this.$message.error('绑定失败')
      } finally {
        this.binding = false
      }
    },
    async unbindTeacher(row) {
      if (!row || !row.teacherUserId) return
      try {
        const res = await unbindOrgTeacher(row.teacherUserId)
        if (res && res.code === 1) {
          this.$message.success('解绑成功')
          await this.loadTeachers()
        } else {
          this.$message.error((res && res.msg) || '解绑失败')
        }
      } catch (e) {
        console.error('解绑失败:', e)
        this.$message.error('解绑失败')
      }
    },
    formatTime(time) {
      if (!time) return '-'
      if (typeof time === 'string') return time.replace('T', ' ').substring(0, 19)
      return time
    }
  }
}
</script>

<style scoped>
.org-teachers {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.empty {
  padding: 20px;
  text-align: center;
  color: #909399;
}
</style>
